import React from 'react'
import { Row, Col, ControlLabel, Alert } from 'react-bootstrap'

import { CancelReason } from './types'

// The step-2 retry state after a partial remove-spot failure.
export const FailedSpotRetry = ({
  count,
  worker,
  reason,
  reasonLabel,
  failedSpotShiftIds,
}: {
  count: number
  worker: { first_name?: string; last_name?: string }
  reason: CancelReason
  reasonLabel: string | null | undefined
  failedSpotShiftIds: number[]
}) => (
  <Row>
    <Col md={12}>
      <ControlLabel>
        Cancelled {count} {count === 1 ? 'shift' : 'shifts'} for {worker.first_name} {worker.last_name} ·
        reason: {reasonLabel ?? reason}
      </ControlLabel>
      <Alert bsStyle="danger">
        <strong>
          The booking was cancelled, but we couldn't remove the{' '}
          {failedSpotShiftIds.length === 1 ? 'spot' : 'spots'} for shift{' '}
          {failedSpotShiftIds.length === 1 ? 'ID' : 'IDs'} {failedSpotShiftIds.join(', ')}.
        </strong>{' '}
        Retry below, or remove {failedSpotShiftIds.length === 1 ? 'it' : 'them'} manually from the listing.
      </Alert>
    </Col>
  </Row>
)
